import { useEffect } from "react";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const useTitle = (title: string) =>
  useEffect(() => {
    const prevTitle = document.title;
    document.title = `${title} | Codat`;
    return () => {
      document.title = prevTitle;
    };
  }, [title]);
